import assertNever from 'assert-never';
import flow from 'lodash/flow';
export const toNum = (weekDay) => {
    switch (weekDay) {
        case 'MONDAY':
            return 0;
        case 'TUESDAY':
            return 1;
        case 'WEDNESDAY':
            return 2;
        case 'THURSDAY':
            return 3;
        case 'FRIDAY':
            return 4;
        case 'SATURDAY':
            return 5;
        case 'SUNDAY':
            return 6;
        default:
            assertNever(weekDay);
    }
};
export const fromNum = (num) => {
    switch (num) {
        case 0:
            return 'MONDAY';
        case 1:
            return 'TUESDAY';
        case 2:
            return 'WEDNESDAY';
        case 3:
            return 'THURSDAY';
        case 4:
            return 'FRIDAY';
        case 5:
            return 'SATURDAY';
        case 6:
            return 'SUNDAY';
        default:
            assertNever(num);
    }
};
export const numPrev = (num) => num === 0 ? 6 : (num - 1);
export const numNext = (num) => num === 6 ? 0 : (num + 1);
export const numDistance = (a, b) => b > a ? b - a : 6 - a + b + 1;
export const next = flow(toNum, numNext, fromNum);
export const prev = flow(toNum, numPrev, fromNum);
export const distance = (a, b) => numDistance(toNum(a), toNum(b));
//# sourceMappingURL=WeekDay.js.map